var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
//
import api from '../core/utils/api';
import handleError from '../core/utils/handleError';
// Simple feed section
var dataLayer = function (config, section, searchParams, page) {
    return new Promise(function (resolve) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // Determine location
        var callbackLocation = ((_a = section === null || section === void 0 ? void 0 : section.hooks) === null || _a === void 0 ? void 0 : _a.determineLocation)
            ? (_b = section === null || section === void 0 ? void 0 : section.hooks) === null || _b === void 0 ? void 0 : _b.determineLocation()
            : null;
        var defaultLocation = (_c = section === null || section === void 0 ? void 0 : section.options) === null || _c === void 0 ? void 0 : _c.defaultLocation;
        var place = (_d = section === null || section === void 0 ? void 0 : section.options) === null || _d === void 0 ? void 0 : _d.place;
        var municipality = (_e = section === null || section === void 0 ? void 0 : section.options) === null || _e === void 0 ? void 0 : _e.municipality;
        var province = (_f = section === null || section === void 0 ? void 0 : section.options) === null || _f === void 0 ? void 0 : _f.province;
        var priortiseOurContent = !!JSON.parse(((_g = section === null || section === void 0 ? void 0 : section.options) === null || _g === void 0 ? void 0 : _g.priortiseOurContent) || false);
        var hideRememberMe = !!JSON.parse(((_h = section === null || section === void 0 ? void 0 : section.options) === null || _h === void 0 ? void 0 : _h.hideRememberMe) || false);
        var hideRegular = !!JSON.parse(((_j = section === null || section === void 0 ? void 0 : section.options) === null || _j === void 0 ? void 0 : _j.hideRegular) || false);
        var fallbackLocation = 'all';
        var location = callbackLocation
            ? callbackLocation
            : defaultLocation
                ? defaultLocation
                : fallbackLocation;
        // determine amount
        var amount = ((_k = section === null || section === void 0 ? void 0 : section.options) === null || _k === void 0 ? void 0 : _k.numOfCards) || 12;
        var defaultPage = page || ((_l = section === null || section === void 0 ? void 0 : section.options) === null || _l === void 0 ? void 0 : _l.defaultPage) || 1;
        // buildAPIUrl
        var endpoint = 'person/search';
        var paramaters = __spreadArray([], (searchParams || []), true);
        // Has birthPlace and passingPlace
        // So overwrite default location in config
        var getParam = function (key) {
            return paramaters.filter(function (param) { return param.key === key; })[0];
        };
        var hasBirthPlaceOrPassingPlace = getParam('passingPlace') || getParam('birthPlace');
        if (amount) {
            paramaters.push({
                key: 'limit',
                value: amount,
            });
        }
        // @deprecated: Is being replaced by place, municipality and province
        if (location && location !== 'all' && !hasBirthPlaceOrPassingPlace) {
            paramaters.push({
                key: 'passingPlace',
                value: location,
            });
            paramaters.push({
                key: 'birthPlace',
                value: location,
            });
        }
        priortiseOurContent &&
            paramaters.push({
                key: 'prio',
                value: priortiseOurContent,
            });
        hideRememberMe &&
            paramaters.push({
                key: 'hideRememberMe',
                value: hideRememberMe,
            });
        hideRegular &&
            paramaters.push({
                key: 'hideRegular',
                value: hideRegular,
            });
        place &&
            paramaters.push({
                key: 'place',
                value: place,
            });
        municipality &&
            paramaters.push({
                key: 'municipality',
                value: municipality,
            });
        province &&
            paramaters.push({
                key: 'province',
                value: province,
            });
        if (defaultPage && defaultPage !== 1) {
            paramaters.push({
                key: 'from',
                value: amount * defaultPage,
            });
        }
        // Make API call
        api(endpoint, paramaters, {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (data) {
            resolve(data);
        })
            .catch(function (error) {
            handleError({
                section: 'dataLayer',
                message: "Get feed content request failed x",
            });
            resolve([]);
        });
    });
};
export default dataLayer;
